import './MaleStyles.css';

function MaleStyles() {
  return (
      <h3 className='Male'>
        Male Style
      </h3>
  );
}

export default MaleStyles;